import AppController from './AppController';
import config from 'config';
/**
 * To Manage the Trip request
 */
class ServiceClubModuleController extends AppController {
	/**
	 * Configure controller
	 */
	constructor() {
		super();
		this.index = this.index.bind(this);
	}
	/**
	* @param {Object} req The request object
	* @param {Object} res The response object
	* @param {function} next The callback to the next program handler
	* @return {void}
	*/
	index(req, res, next) {
		var dataJson = {};
		dataJson.baseUrl = config.get('app.baseUrl');
		dataJson.pageTitle = "Club Management Consulting Solution | Automation Software - JogaApp";
		dataJson.metaDescription = "Become a partner of JogaApp and provide the best service to your clients and the most effective club management solution for your organization.";
		dataJson.metaKeyword = "Club Management Solution, Club Management Consulting, Automation Software";
		res.render('serivce/club-module',dataJson);
	}
}

export default ServiceClubModuleController;
